import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { UserRoutingModule } from './user-rouning.module';
import { AppUiModule } from '../../ui/app-ui.module';
import { ChangePasswordAuthUserComponent } from './change-password-auth-user/change-password-auth-user.component';
import { UserService } from './user.service';

@NgModule({
  declarations: [ChangePasswordAuthUserComponent],
  imports: [CommonModule, ReactiveFormsModule, UserRoutingModule, AppUiModule],
  providers: [UserService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserModule {}
